import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Card, Pill, Label, Paragraph } from '@treams/treams-ui';
import { EvaluationSectionItem } from 'generated/graphql';
import { ItemTypeLabelMapper, QuestionLabelMapper } from '../helpers';

export const SelectConversationTypeCardQuestion = ({
	type,
	title,
	...rest
}: EvaluationSectionItem) => {
	let content: string | undefined = '';
	const typeLabel = ItemTypeLabelMapper(type);

	if (title) {
		return null;
	} else {
		const questionToDisplay =
			rest.finalScore ||
			rest.multipleChoice ||
			rest.reviewGoals ||
			rest.sentiment ||
			rest.competency ||
			rest.signature ||
			rest.openQuestion ||
			rest.stars;

		if (questionToDisplay) {
			/* type narrowing to filter out unique cases where title is nested deeper */
			content = QuestionLabelMapper(questionToDisplay);
		}
	}

	return typeLabel ? (
		<Card mb={1} banner="primary">
			<Box display="flex" flexDirection="row" alignItems="center">
				<Flex width="80%" flexGrow={1}>
					<Paragraph>{content}</Paragraph>
				</Flex>

				<Pill small lightBlue textAlign="center" ml={2}>
					<StyledLabel>{typeLabel}</StyledLabel>
				</Pill>
			</Box>
		</Card>
	) : null;
};

const StyledLabel = styled(Label)`
	white-space: nowrap;
	font-weight: bold;
`;
